module.exports = __webpack_public_path__ + "img/Trophy.f8534603.svg";